import { usePage } from "@inertiajs/react";
import { lazy, useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import Suspense from "components/shared/Suspense";
import Container from "hardcover-ui/components/Container";
import LoadingSpinner from "hardcover-ui/components/LoadingSpinner";
import Modal from "hardcover-ui/components/Modal";
import { useReport } from "store/ui/uiSelector";
import { uiActions } from "store/ui/uiSlice";
import { DefaultPageType } from "types/DefaultPageType";

const ReportModalContent = lazy(() => import("./ReportModalContent"));

export default function ReportModal() {
  const report = useReport();
  const showModalTab = report ? typeof report !== "undefined" : false;

  const dispatch = useDispatch();
  const { pathName } = usePage<DefaultPageType>().props;
  const [initialPath] = useState(pathName);

  const closeModal = useCallback(() => {
    dispatch(uiActions.endReport());
  }, [report]);

  // Close the modal if they navigate to a different page
  useEffect(() => {
    if (initialPath !== pathName) {
      dispatch(uiActions.endReport());
    }
  }, [pathName]);

  return (
    <Modal
      onClose={closeModal}
      open={showModalTab}
      size="sm"
      position="center"
      modalTitle="Report"
    >
      <Container size="sm" variant="primary" className="px-4 py-4">
        {showModalTab && (
          <Suspense fallback={<LoadingSpinner size="lg" variant="layout" />}>
            <ReportModalContent report={report} onClose={closeModal} />
          </Suspense>
        )}
      </Container>
    </Modal>
  );
}
